// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.___psong_detail {
  padding: 0 20px 0px 20px;
}
@media (max-width: 576px) {
  .___psong_detail {
    padding: 0 20px;
    width: 140vw;
  }
}
.___psong_detail .___psong_detail_box {
  width: 60%;
  position: relative;
}
@media screen and (max-width: 992px) {
  .___psong_detail .___psong_detail_box {
    width: 100%;
    padding-left: 0;
  }
}
@media (max-width: 576px) {
  .___psong_detail .___psong_detail_box {
    width: 100%;
    padding-left: 0;
  }
}
.___psong_detail .___psong_detail_box .___song_detail_container {
  position: relative;
}
@media screen and (max-width: 992px) {
  .___psong_detail .___psong_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail {
    flex-direction: column;
  }
}
@media (max-width: 576px) {
  .___psong_detail .___psong_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail {
    flex-direction: column;
  }
  .___psong_detail .___psong_detail_box .___song_detail_container .___song_detail_banner .___song_detail_banner_detail ._img_large {
    margin: auto;
  }
}
.___psong_detail .___psong_detail_box .___song_detail_more .___buy_option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #090909;
  border-radius: 16px;
  padding: 16px 20px;
  min-height: 82px;
}
@media (max-width: 576px) {
  .___psong_detail .___psong_detail_box .___song_detail_more .___buy_option {
    flex-direction: column;
    gap: 20px;
  }
  .__buy_container {
    flex-direction: row !important;
    gap: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/pages/PlaylistNftDetail/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACI,wBAAA;AA4BJ;ADME;ECnCF;IAIQ,eAAA;IACA,YAAA;EA6BN;AACF;AA3BI;EACI,UAAA;EACA,kBAAA;AA6BR;AA3BQ;EAJJ;IAKQ,WAAA;IACA,eAAA;EA8BV;AACF;ADVE;EC3BE;IAUQ,WAAA;IACA,eAAA;EA+BV;AACF;AA7BQ;EACI,kBAAA;AA+BZ;AAzBoB;EADJ;IAEQ,sBAAA;EA4BtB;AACF;ADxBE;ECPc;IAMQ,sBAAA;EA6BtB;EA1BkB;IAEQ,YAAA;EA6B1B;AAJF;AAjBY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAwBhB;AD3CE;ECYU;IAUQ,sBAAA;IACA,SAAA;EAyBlB;EAlBE;IACI,8BAAA;IACA,SAAA;EAuBN;AANF","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.___psong_detail {\n    padding: 0 20px 0px 20px;\n\n    @include sm {\n        padding: 0 20px;\n        width: 140vw;\n    }\n\n    .___psong_detail_box {\n        width: 60%;\n        position: relative;\n\n        @media screen and (max-width:992px) {\n            width: 100%;\n            padding-left: 0;\n        }\n\n        @include sm {\n            width: 100%;\n            padding-left: 0;\n        }\n\n        .___song_detail_container {\n            position: relative;\n\n            .___song_detail_banner {\n\n\n                .___song_detail_banner_detail {\n                    @media screen and (max-width:992px) {\n                        flex-direction: column;\n                    }\n\n                    @include sm {\n                        flex-direction: column;\n                    }\n\n                    ._img_large {\n                        @include sm {\n                            margin: auto;\n                        }\n                    }\n                }\n            }\n        }\n\n        .___song_detail_more {\n            .___buy_option {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                background-color: #090909;\n                border-radius: 16px;\n                padding: 16px 20px;\n                min-height: 82px;\n\n                @include sm {\n                    flex-direction: column;\n                    gap: 20px;\n                }\n            }\n        }\n    }\n}\n@media (max-width: 576px) {\n    .__buy_container {\n        flex-direction: row !important;\n        gap: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
